import { 
  SET_DATA_TAG_REPORTS,
  SET_DATA_TAG_ALL_REPORTS,
  SET_DATA_TAG_REPORTS_LOADER,
  SET_DATA_TAG_DOWNLOAD_LOADER,
  SET_DATA_TAG_SNACKBAR,
  CLEAR_DATA_TAG_SNACKBAR,
  SET_UPLOAD_PROGRESS,
  CLEAR_UPLOAD_STATE,
  UPLOAD_DATA_TAG_REPORT,
  UPLOAD_DATA_TAG_REPORT_SUCCESS,
  UPLOAD_DATA_TAG_REPORT_FAILURE
} from "../../features/Data Tag/DataTagConstants";

const initialState = {
  allReports: [], // Store all fetched reports
  dataTagReports: [], // Currently displayed reports (filtered/paginated)
  loader: false,
  downloadLoader: false,
  snackBarMessage: {},
  uploadProgress: 0,
  uploadLoader: false,
  uploadSnackBarMessage: {},
}

export const DataTagReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_TAG_ALL_REPORTS: {
      return {
        ...state,
        allReports: action.payload
      }
    }
    case SET_DATA_TAG_REPORTS: {
      return {
        ...state,
        dataTagReports: action.payload
      }
    }
    case SET_DATA_TAG_REPORTS_LOADER: {
      return {
        ...state,
        loader: action.payload
      }
    }
    case SET_DATA_TAG_DOWNLOAD_LOADER: {
      return {
        ...state,
        downloadLoader: action.payload
      }
    }
    case SET_DATA_TAG_SNACKBAR: {
      return {
        ...state,
        snackBarMessage: action.payload
      }
    }
    case CLEAR_DATA_TAG_SNACKBAR: {
      return {
        ...state,
        snackBarMessage: {}
      }
    }
    case UPLOAD_DATA_TAG_REPORT: {
      return {
        ...state,
        uploadLoader: true,
        uploadProgress: 0,
        uploadSnackBarMessage: {}
      }
    }
    case SET_UPLOAD_PROGRESS: {
      return {
        ...state,
        uploadProgress: action.payload
      }
    }
    case UPLOAD_DATA_TAG_REPORT_SUCCESS: {
      return {
        ...state,
        uploadLoader: false,
        uploadProgress: 0,
        uploadSnackBarMessage: {
          status: "success",
          message: action.payload || "Report uploaded successfully!"
        }
      }
    }
    case UPLOAD_DATA_TAG_REPORT_FAILURE: {
      return {
        ...state,
        uploadLoader: false,
        uploadProgress: 0,
        uploadSnackBarMessage: {
          status: "error",
          message: action.payload || "Failed to upload report."
        }
      }
    }
    case CLEAR_UPLOAD_STATE: {
      return {
        ...state,
        uploadProgress: 0,
        uploadLoader: false,
        uploadSnackBarMessage: {}
      }
    }
    default:
      return state;
  }
}
